import { ca } from '@cian/analytics';

interface ITrackNewbuildingComparisonParams {
  label: string;
  products: unknown;
  page: Record<string, unknown>;
}

export function trackAddNewbuildingComparison({ label, products, page }: ITrackNewbuildingComparisonParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'Add',
    label,
    products,
    page: toMapPage(page),
  });
}

export function trackDeleteNewbuildingComparison({ label, products, page }: ITrackNewbuildingComparisonParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'Remove',
    label,
    products,
    page: toMapPage(page),
  });
}

function toMapPage(page: Record<string, unknown>) {
  return { ...page, pageType: 'Map' };
}
